import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { UserRole } from '../types';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
  requireAuth?: boolean;
}

export function ProtectedRoute({
  children,
  allowedRoles,
  requireAuth = true,
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, user } = useAuthStore();

  // If authentication is not required, render children
  if (!requireAuth) {
    return <>{children}</>;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If roles are specified, check if user has the required role
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role)) {
      // Redirect to appropriate dashboard based on role
      const dashboards: Record<string, string> = {
        CUSTOMER: '/shop',
        MERCHANT: '/',
        OWNER: '/',
        STAFF: '/',
        CO_OWNER: '/',
        ADMIN: '/',
        SUPER_ADMIN: '/',
        AFFILIATE: '/affiliate',
      };
      return <Navigate to={dashboards[user.role] || '/'} replace />;
    }
  }

  return <>{children}</>;
}
